module.exports = __webpack_public_path__ + "3d2e649f08d4522fa03eb0c652fe0fc4.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/800.png
// module id = 1705
// module chunks = 2